import { Flex, Stack } from '@chakra-ui/react';
import ButtonLink from '~/components/ButtonLink';
import Image from '~/components/Image';
import Text from '~/components/Text';
import React from 'react';
import { createImageWithArtDirection } from '../utils/imageUtils';

var NotFoundPage = function NotFoundPage(props) {
  var _data$allWpSiteSettin, _acfData$hero, _acfData$hero2, _acfData$hero3, _acfData$hero4;

  var data = props.data;
  var acfData = (_data$allWpSiteSettin = data.allWpSiteSetting.nodes.find(function (node) {
    var _node$acf, _node$acf$errorFields, _node$acf$errorFields2;

    return node === null || node === void 0 ? void 0 : (_node$acf = node.acf404) === null || _node$acf === void 0 ? void 0 : (_node$acf$errorFields = _node$acf.errorFields) === null || _node$acf$errorFields === void 0 ? void 0 : (_node$acf$errorFields2 = _node$acf$errorFields.hero) === null || _node$acf$errorFields2 === void 0 ? void 0 : _node$acf$errorFields2.title;
  })) === null || _data$allWpSiteSettin === void 0 ? void 0 : _data$allWpSiteSettin.acf404.errorFields;
  if (!acfData) return null;
  var heroImageWithArtDirection = createImageWithArtDirection({
    desktopImage: (_acfData$hero = acfData.hero) === null || _acfData$hero === void 0 ? void 0 : _acfData$hero.desktopFeaturedImage,
    mobileImage: (_acfData$hero2 = acfData.hero) === null || _acfData$hero2 === void 0 ? void 0 : _acfData$hero2.mobileFeaturedImage
  });
  return /*#__PURE__*/React.createElement(Flex, {
    minH: "100vh",
    h: "100%",
    w: "100%",
    position: "relative",
    zIndex: 0,
    align: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    image: heroImageWithArtDirection,
    withOverlay: true,
    overlayOpacity: 0.4
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: 4,
    maxW: {
      base: '90%',
      xl: '80%'
    },
    mx: "auto",
    w: "100%",
    textAlign: {
      base: 'center',
      xl: 'left'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textVariant: "h1"
  }, (_acfData$hero3 = acfData.hero) === null || _acfData$hero3 === void 0 ? void 0 : _acfData$hero3.title), /*#__PURE__*/React.createElement(Text, {
    textVariant: "h2",
    fontWeight: "bold",
    color: "white"
  }, (_acfData$hero4 = acfData.hero) === null || _acfData$hero4 === void 0 ? void 0 : _acfData$hero4.tagline), /*#__PURE__*/React.createElement(ButtonLink, {
    cta: acfData.cta
  })));
};

export default NotFoundPage;
var query = "4063475174";